import { IconNames } from '@blueprintjs/icons';
import { formatDate, formatNameLastFirst } from '@strata/helper-functions';
import { Grid, SecondaryData } from '@strata/react-grid';
import { MessagingBlock } from '@strata/react-messaging-block';
import { IntakeStatusIndicator } from '@strata/react-status-indicators';
import PropTypes from 'prop-types';

const initialSortProperties = [{ id: 'create_date', desc: true }];

const columns = [
    {
        accessorKey: 'prescriber_last_name',
        header: 'Prescriber',
        size: 110,
        cell: ({ row }) => (
            <SecondaryData
                data={formatNameLastFirst(
                    row.original.prescriber_last_name,
                    row.original.prescriber_first_name,
                )}
            />
        ),
    },
    {
        accessorKey: 'create_date',
        header: 'Created Date',
        size: 110,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        accessorKey: 'submit_date',
        header: 'Submitted Date',
        size: 110,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        accessorKey: 'last_updated',
        header: 'Last Updated',
        size: 110,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        accessorKey: 'intake_status',
        header: 'Intake Case Status',
        size: 110,
        enableSorting: false,
        cell: ({ getValue }) => <IntakeStatusIndicator status={getValue()} />,
    },
    {
        accessorKey: 'status_detail',
        header: 'Status Details',
        size: 110,
        enableSorting: false,
    },
];

export const IntakeCaseDetails = ({ cases = undefined, isLoading = true }) => (
    <Grid
        data={cases}
        isLoading={isLoading}
        sortProperties={initialSortProperties}
        noResults={
            <div className="padding__around--large">
                <MessagingBlock
                    size={MessagingBlock.Sizes.SMALL}
                    icon={IconNames.DOCUMENT}
                    primaryText="No Intake Cases available"
                />
            </div>
        }
        columns={columns}
    />
);

IntakeCaseDetails.propTypes = {
    cases: PropTypes.arrayOf(
        PropTypes.shape({
            prescriber: PropTypes.string,
            create_date: PropTypes.string,
            submit_date: PropTypes.string,
            last_updated: PropTypes.string,
            intake_case_status: PropTypes.string,
            status_details: PropTypes.string,
        }),
    ),
    isLoading: PropTypes.bool,
};
